import styles from "./styles.module.scss";
import { useMemo, useState } from "react";
import classNames from "classnames";
import BankInformation from "./components/BankInformation";
import DocumentationInformation from "./components/DocumentationInformation";
import TiersInformation from "./components/TiersInformation";
import UsersInformation from "./components/UsersInformation";
import ClientsInformation from "./components/ClientsInformation";
import LockerShipmentSettlement from "./components/LockerShipmentSettlement";
import { useOrganisationStore } from "../../../providers/organisation/organisation.provider";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const LOCKER_SETTLEMENT_TAB_ID = 5;
const API_CLIENTS_TAB_ID = 4;

interface BusinessSettingsProps {
  isServiceProvider?: boolean;
}

const BusinessSettings = ({
  isServiceProvider = false,
}: BusinessSettingsProps) => {
  const { t } = useTranslation();
  // Service providers land on the shipping-fee settlement tab — it's why the
  // admin opened the provider from the Service Providers list.
  // The auto-consent requests tab links here with ?tab=api-clients (and ?client=<id>).
  const [searchParams] = useSearchParams();
  const [selectedIndex, setSelectedIndex] = useState(
    isServiceProvider
      ? LOCKER_SETTLEMENT_TAB_ID
      : searchParams.get("tab") === "api-clients"
      ? API_CLIENTS_TAB_ID
      : 0
  );
  const organization = useOrganisationStore(
    (state) => state.selectedOrganisation
  );

  const list = useMemo(() => {
    return [
      {
        id: 0,
        title: "إدارة المستخدمين",
      },
      {
        id: 1,
        title: "بيانات الحساب البنكي",
      },
      {
        id: 2,
        title: "الملفات والتوثيق",
      },
      {
        id: 3,
        title: "اتفاقية وفّي",
      },
      {
        id: 4,
        title: t("lbl_api_clients"),
      },
      ...(isServiceProvider
        ? [{ id: LOCKER_SETTLEMENT_TAB_ID, title: "تسوية رسوم الشحن" }]
        : []),
    ];
  }, [t, isServiceProvider]);

  return (
    <div className={styles.container}>
      <h1 className={styles.topHeader}>{t("lbl_settings")}</h1>
      <div className={styles.tabContainer}>
        {list?.map((listItem) => (
          <li
            onClick={() => setSelectedIndex(listItem?.id)}
            key={listItem?.title}
            className={classNames(
              styles.listItem,
              {
                [styles.listItemSelected]: listItem?.id === selectedIndex,
              },
              { [styles.firstItem]: listItem?.id === 0 },
              {
                [styles.lastItem]:
                  listItem?.id === list?.[list?.length - 1]?.id,
              }
            )}>
            {listItem?.title}
          </li>
        ))}
      </div>
      {selectedIndex === 0 && <UsersInformation organization={organization} />}
      {selectedIndex === 1 && <BankInformation organization={organization} />}
      {selectedIndex === 2 && (
        <DocumentationInformation organization={organization} />
      )}
      {selectedIndex === 3 && (
        <TiersInformation organization={organization} isEditable />
      )}
      {selectedIndex === 4 && (
        <ClientsInformation organization={organization} />
      )}
      {selectedIndex === LOCKER_SETTLEMENT_TAB_ID && isServiceProvider && (
        <LockerShipmentSettlement />
      )}
    </div>
  );
};

export default BusinessSettings;
